<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" clearable placeholder="名称/联系电话/联系地址"
             style="width: 200px; margin-right:3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectServiceDatetime" placeholder="选择日期"
                  style="margin-right: 3px; width: 200px;"></DatePicker>
      <Button size="small" type="primary" @click="onFilterClick">查询</Button>
      <Dropdown size="small" style="margin-right: 3px" @on-click="DropdownonFilterClick">
        <Button  size="small" type="primary">
<!--          查询-->
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="createDatetime">创建时间</DropdownItem>
          <DropdownItem name="maintainDatetime">完成时间</DropdownItem>
          <DropdownItem name="bookingDatetime">预约时间</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="addMaintainOrderModal=true">添加维修订单</Button>
      <!--<Button type="primary" size="small" @click="onTest">测试</Button>-->
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :row-class-name="rowClassName"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)">
          </Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator
              @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <web-table-columns-modal v-model="webTableColumnsModal" :columnList.sync="columns"
                             :tableName="$options.name" @on-column-update="onColumnUpdate"></web-table-columns-modal>
    <add-maintain-order-modal v-model="addMaintainOrderModal" @on-success="onSuccess"></add-maintain-order-modal>
    <maintain-order-detail-modal v-model="maintainOrderDetailModal" :initValue="maintainOrderDetailId"></maintain-order-detail-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <maintain-order-change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserId"
                                               @on-success="onModifySuccess"></maintain-order-change-business-user-modal>
    <maintain-order-add-to-remark-modal v-model="maintainOrderAddToRemarkModal" :initValue="maintainOrderAddToRemarkId"
                                        @on-success="onModifySuccess"></maintain-order-add-to-remark-modal>
    <maintain-order-change-maintainer-modal v-model="maintainOrderChangeMaintainerModal" :initValue="maintainOrderChangeMaintainerId"
                                            @on-success="onModifySuccess"></maintain-order-change-maintainer-modal>
    <maintain-vehicle-picture-modal v-model="maintainVehiclePictureModal" :initValue="maintainVehiclePictureModalId"
                                    @on-success="onModifySuccess"></maintain-vehicle-picture-modal>
  </div>
</template>

<script>

import AddMaintainOrderModal from '@/view/om/components/add-maintain-order-modal'
import MaintainOrderDetailModal from '@/view/om/components/maintain-order-detail-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import MaintainOrderChangeBusinessUserModal from '@/view/om/components/maintain-order-change-business-user-modal'
import MaintainOrderAddToRemarkModal from '@/view/om/components/maintain-order-add-to-remark-modal'
import MaintainOrderChangeMaintainerModal from '@/view/om/components/maintain-order-change-maintainer-modal'
import MaintainVehiclePictureModal from '@/view/om/components/maintain-vehicle-picture-modal'

// import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  name: 'mybusinessmaintainorders',
  components: {
    AddMaintainOrderModal,
    MaintainOrderDetailModal,
    VehicleInfoDetailModal,
    MaintainOrderChangeBusinessUserModal,
    MaintainOrderAddToRemarkModal,
    MaintainOrderChangeMaintainerModal,
    MaintainVehiclePictureModal
  },
  data () {
    return {
      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      addMaintainOrderModal: false,

      // 指派维修员
      maintainOrderChangeMaintainerModal: false,
      maintainOrderChangeMaintainerId: null,

      // 查看修改维修订单
      maintainOrderDetailModal: false,
      maintainOrderDetailId: null,

      // 追加备注
      maintainOrderAddToRemarkModal: false,
      maintainOrderAddToRemarkId: null,

      marketsales: null,
      maintainers: null,

      selectServiceDatetime: [],
      changesimFilter: null,
      maintainTypeFilter: null,
      stateFilter: null,
      receptFilter: null,
      fileReadyFilter: null,
      businessUserFilter: null,
      maintainerFilter: null,
      billTypeFilter: null,
      salesChannelFilter: null,
      FilterClickFilter: null,
      timeoutLogoFilter: null,

      // 追加备注
      addToRemarkModal: false,
      addToRemarkId: null,

      // 指定业务跟进
      changeBusinessUserModal: false,
      changeBusinessUserId: null,

      // 续费订单作废
      maintainOrderCancelModal: false,
      maintainOrderCancelId: null,

      // 订单基本信息
      maintainOrderBaseDetailModal: false,
      maintainOrderBaseDetailId: null,

      // 车辆信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 维修图片管理
      maintainVehiclePictureModal: false,
      maintainVehiclePictureModalId: null,

      // 确认收款
      confirmReceptModal: false,
      confirmReceptId: null,

      // 维修订单详细信息
      maintainOrderDetailModal: false,
      maintainOrderDetailId: null,

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      // columnsDisplay: [],
      // columnHeaders: [],
      columns: [
        {
          title: '订单号',
          resizable: true,
          key: 'orderNum',
          sortable: 'custom',
          width: 180
        },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let vin = ''
            if (params.row.vehicleInfo) {
              registrationNum = params.row.vehicleInfo.registrationNum === null ? '无' : params.row.vehicleInfo.registrationNum
              vin = params.row.vehicleInfo.vin === null ? '无' : params.row.vehicleInfo.vin
            }
            return h('div', [
              h('div', '车牌:' + registrationNum),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: '客户/分组名',
          resizable: true,
          key: 'vehicleInfo.vehicleInfoGroupId',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            let display = []
            if (params.row.vehicleInfo) {
              if (params.row.vehicleInfo.clientInfo) {
                display.push(h('div', '客户信息:' + params.row.vehicleInfo.clientInfo.name + '(' + params.row.vehicleInfo.clientInfo.phoneNum + ')'))
              } else {
                display.push(h('div', '客户信息:无'))
              }
              if (params.row.vehicleInfo.vehicleInfoGroup) {
                display.push(h('div', '分组:' + params.row.vehicleInfo.vehicleInfoGroup.name))
              } else {
                display.push(h('div', '分组:无'))
              }
              return h('div', display)
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName != null) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName != null) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name != null) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '维修员',
          resizable: true,
          key: 'maintainerId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 100,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.maintainerFilter = []
              val.forEach(item => {
                if (item == null) {
                  this.maintainerFilter.push(genQueryParam('maintainerId', 'EQNULL'))
                } else {
                  this.maintainerFilter.push(genQueryParam('maintainerId', 'EQ', item))
                }
              })
            } else {
              this.maintainerFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.maintainer) {
              let name = null
              if (params.row.maintainer.realName) {
                name = params.row.maintainer.realName
              } else if (params.row.maintainer.nickName) {
                name = params.row.maintainer.nickName
              } else if (params.row.maintainer.name) {
                name = params.row.maintainer.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '订单类型',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          filters: [
            { label: '维修', value: 0 },
            { label: '返修', value: 1 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.maintainTypeFilter = []
              val.forEach(item => {
                this.maintainTypeFilter.push(genQueryParam('maintainType', 'EQ', item))
              })
            } else {
              this.maintainTypeFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            if (state === 0) {
              return h('div', '维修')
            } else if (state === 1) {
              return h('div', '返修')
            }
          }
        },
        {
          title: '加急订单',
          resizable: true,
          key: 'urgent',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          render: (h, params) => {
            const urgent = params.row.urgent
            if (urgent != null) {
              if (urgent) {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'error'
                    }
                  }, '加急')
                ])
              } else {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'blue'
                    }
                  }, '普通')
                ])
              }
            }
          }
        },
        {
          title: '订单状态',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '异常', value: -1 },
            { label: '作废', value: 0 },
            { label: '指派', value: 1 },
            { label: '维修', value: 2 },
            { label: '完成', value: 3 },
            // { label: '审核', value: 4 },
            { label: '配货', value: 5 },
            { label: '回访', value: 6 }
            // { label: '收款', value: 7 },
          ],
          filterMultiple: true,
          // filteredValue: [1,2,3,4,5,6,7],
          filteredValue: [1, 2, 3, 5, 6],
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            let step = null
            if (params.row.step != null) {
              step = params.row.step.state
            } else {
              step = 1
            }
            if (state === 1) {
              if (params.row.installer != null) {
                step = 2
              }
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待指派')
              } else if (step === 2) {
                return h('div', '已指派')
              } else if (step === 3) {
                return h('div', '指派失败')
              }
            } else if (state === 2) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待维修')
              } else if (step === 2) {
                return h('div', '维修成功')
              } else if (step === 3) {
                return h('div', '维修失败')
              }
            } else if (state === 3) {
              return h('div', '完成')
            } else if (state === 0) {
              return h('div', '作废')
            } else if (state === -1) {
              return h('div', '异常')
            } else if (state === 4) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '审核中')
              } else if (step === 2) {
                return h('div', '审核通过')
              } else if (step === 3) {
                return h('div', '审核不通过')
              }
            } else if (state === 5) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待配货')
              } else if (step === 2) {
                return h('div', '已配货')
              } else if (step === 3) {
                return h('div', '配货失败')
              }
            } else if (state === 6) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待回访')
              } else if (step === 2) {
                return h('div', '已回访')
              } else if (step === 3) {
                return h('div', '回访失败')
              }
            } else if (state === 7) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待收款')
              } else if (step === 2) {
                return h('div', '已收款')
              } else if (step === 3) {
                return h('div', '收款失败')
              }
            }
          }
        },
        {
          title: '结果',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.step != null) {
              if (params.row.step.result) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, params.row.step.result)
              } else {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '无')
              }
            }
          }
        },
        {
          title: '是否换卡',
          resizable: true,
          key: 'maintainDeviceRecords',
          ellipsis: 'true',
          tooltip: 'true',
          width: 90,
          // filters: [
          //   { label: '是', value: 1 },
          //   { label: '否', value: 2 },
          // ],
          // filterMultiple: false,
          // // filterRemote: (val) => {
          // //   if (val && val.length > 0) {
          // //     this.changesimFilter = []
          // //     val.forEach(item => {
          // //       this.changesimFilter.push(genQueryParam('maintainDeviceRecords', 'EQ', item))
          // //     })
          // //   } else {
          // //     this.changesimFilter = null
          // //   }
          // //   this.setPage(1)
          // // },
          // filterMethod (value, row) {
          //   if (value === 1) {
          //     for (let i = 0; i < row.maintainDeviceRecords.length; i++) {
          //       if (row.maintainDeviceRecords[i].changeSim){
          //         return row.maintainDeviceRecords[i].changeSim ===true;
          //       }else {
          //         return row.maintainDeviceRecords[i].changeSim ===true;
          //       }
          //     }
          //
          //   } else if (value === 2) {
          //     for (let i = 0; i < row.maintainDeviceRecords.length; i++) {
          //       if (row.maintainDeviceRecords[i].changeSim){
          //         return row.maintainDeviceRecords[i].changeSim ===false;
          //       }else {
          //         return row.maintainDeviceRecords[i].changeSim ===false;
          //       }
          //     }
          //   }
          // },
          render: function (h, params) {
            // console.log(params.row)
            // console.log(params.row.maintainDeviceRecords)
            if (params.row.maintainDeviceRecords != null) {
              for (let i = 0; i < params.row.maintainDeviceRecords.length; i++) {
                if (params.row.maintainDeviceRecords[i].changeSim) {
                  return h('div', '是')
                } else {
                  return h('div', '否')
                }
              }
            } else {
              return h('div', '否')
            }
          }
        },
        {
          title: '换卡记录',
          resizable: true,
          key: 'maintainDeviceRecords',
          ellipsis: 'true',
          tooltip: 'true',
          width: 320,
          render: function (h, params) {
            if (params.row.maintainDeviceRecords != null) {
              let maintainDeviceRecords = params.row.maintainDeviceRecords
              let d = []
              maintainDeviceRecords.forEach(item => {
                let display = ''
                let oldterminalNum = ''
                let oldSim = null
                let terminalNum = ''
                let Sim = ''
                if (item.changeSim) {
                  if (item.simInfo) {
                    Sim = item.simInfo
                  } else {
                    Sim = '无SIM卡信息'
                  }
                  if (item.oldSimInfoId) {
                    oldSim = item.oldSimInfo.simNum
                  } else {
                    oldSim = '无SIM卡信息'
                  }
                  if (item.oldPositioningDeviceInfoId) {
                    oldterminalNum = item.oldPositioningDeviceInfo.terminalNum
                  } else {
                    oldterminalNum = item.positioningDeviceInfo.terminalNum
                  }

                  if (item.changeDevice) {
                    if (item.changeTerminalNum) {
                      oldterminalNum = item.terminalNum
                      terminalNum = item.newTerminalNum
                      display = '更换前：' + oldterminalNum + '[SIM卡号:' + oldSim + ']'
                      d.push(h('div', display))
                      display = '更换后：' + terminalNum + '[SIM卡号:' + Sim + ']'
                      d.push(h('div', display))
                      // return h('div', d)
                    } else {
                      oldterminalNum = item.terminalNum
                      terminalNum = item.terminalNum
                      display = '更换前：' + oldterminalNum + '[SIM卡号:' + oldSim + ']'
                      d.push(h('div', display))
                      display = '更换后：' + terminalNum + '[SIM卡号:' + Sim + ']'
                      d.push(h('div', display))
                      // return h('div', d)
                    }
                  } else {
                    if (item.changeTerminalNum) {
                      oldterminalNum = item.terminalNum
                      terminalNum = item.newTerminalNum
                      display = '更换前：' + oldterminalNum + '[SIM卡号:' + oldSim + ']'
                      d.push(h('div', display))
                      display = '更换后：' + terminalNum + '[SIM卡号:' + Sim + ']'
                      d.push(h('div', display))
                      // return h('div', d)
                    } else {
                      oldterminalNum = item.terminalNum
                      terminalNum = item.terminalNum
                      display = '更换前：' + oldterminalNum + '[SIM卡号:' + oldSim + ']'
                      d.push(h('div', display))
                      display = '更换后：' + terminalNum + '[SIM卡号:' + Sim + ']'
                      d.push(h('div', display))
                      // return h('div', d)
                    }
                  }
                } else {
                  display = '无'
                  d.push(h('div', display))
                  // return h('div', '无')
                }
              })
              // console.log(d)
              return h('div', d)
            } else {
              return h('div', '无')
            }
          }
        },
        // {
        //   title: '更新时间',
        //   resizable: true,
        //   key: 'updateDatetime',
        //   sortable: 'custom',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   width: 180,
        //   render: function (h, params) {
        //     if (params.row.updateDatetime) {
        //       let d = new Date(params.row.updateDatetime)
        //       return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
        //     }
        //   }
        // },
        {
          title: '超时',
          resizable: true,
          key: 'timeoutLogo',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '未超时', value: 0 },
            { label: '已超时', value: 1 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.timeoutLogoFilter = []
              val.forEach(item => {
                if (item == 1) {
                  this.timeoutLogoFilter.push(genQueryParam('timeoutLogo', 'EQBOOL', true))
                } else {
                  this.timeoutLogoFilter.push(genQueryParam('timeoutLogo', 'EQBOOL', false))
                }
              })
            } else {
              this.timeoutLogoFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.timeoutLogo) {
              return h('div', '已超时')
            } else {
              return h('div', '未超时')
            }
          }
        },
        {
          title: '预约信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 240,
          render: (h, params) => {
            let bookingDatetime
            let bookingPlace
            let actualDatetime
            let actualPlace
            if (params.row.actualDatetime) {
              if (params.row.actualDatetime) {
                actualDatetime = new Date(params.row.actualDatetime).Format('yyyy年MM月dd日 hh:mm')
              } else {
                actualDatetime = '无'
              }
              if (params.row.actualPlace) {
                actualPlace = params.row.actualPlace
              } else {
                actualPlace = '无'
              }
              return h('div', [
                h('div', '重新预约时间:' + actualDatetime),
                h('div', '重新预约地点:' + actualPlace)
              ])
            } else {
              if (params.row.bookingDatetime) {
                bookingDatetime = new Date(params.row.bookingDatetime).Format('yyyy年MM月dd日 hh:mm')
              } else {
                bookingDatetime = '无'
              }
              if (params.row.bookingPlace) {
                bookingPlace = params.row.bookingPlace
              } else {
                bookingPlace = '无'
              }
              return h('div', [
                h('div', '预约时间:' + bookingDatetime),
                h('div', '预约地点:' + bookingPlace)
              ])
            }
          }
        },
        {
          title: '维修完成时间',
          resizable: true,
          key: 'maintainDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.maintainDatetime) {
              let d = new Date(params.row.maintainDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '问题概况',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'question',
          width: 180
        },
        {
          title: '处理结果',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'result',
          width: 180
        },
        {
          title: '备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'remark',
          width: 180
        },
        {
          title: '车辆信息备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'remark',
          width: 180,
          render: function (h, params) {
            let texts = ''
            if (params.row.vehicleInfo.remark) {
              texts = params.row.vehicleInfo.remark

              return h('Tooltip', {
                props: {
                  placement: 'bottom-start'
                }
              }, [texts,
                h('span', {
                  slot: 'content',
                  style: {
                    whiteSpace: 'normal',
                    wordBreak: 'break-all'
                  }
                }, texts)
              ])
            }
          }
        },
        {
          title: '车辆信息历史记录',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'historyRecord',
          width: 200,
          render: function (h, params) {
            let texts = ''
            if (params.row.vehicleInfo.historyRecord) {
              texts = params.row.vehicleInfo.historyRecord

              return h('Tooltip', {
                props: {
                  placement: 'bottom-start'
                }
              }, [texts,
                h('span', {
                  slot: 'content',
                  style: {
                    whiteSpace: 'normal',
                    wordBreak: 'break-all'
                  }
                }, texts)
              ])
            }
          }

        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 300,
          fixed: 'right',
          render: (h, params) => {
            let display = []

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.maintainOrderDetailModal = true
                    this.maintainOrderDetailId = params.row.id
                  }
                }
              }, '订单信息')
            )
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.vehicleInfoId
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '车辆信息')
            )

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.maintainOrderChangeMaintainerId = params.row.id
                    this.maintainOrderChangeMaintainerModal = true
                  }
                }
              }, '指派维修员')
            )

            if (params.row.state != 3 && params.row.state != 0) {
              // console.log('未完成')

              display.push(
                h('Dropdown', {
                  props: {
                    trigger: 'click',
                    transfer: true
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {}
                },
                [
                  h('Button', '更多'),
                  h(
                    'DropdownMenu',
                    {
                      slot: 'list'
                    },
                    [
                      // h('DropdownItem', {
                      //   props: {
                      //     type: 'primary',
                      //     size: 'small',
                      //     disabled: false
                      //   },
                      //   style: {
                      //     marginRight: '5px'
                      //   },
                      //   nativeOn: {
                      //     click: () => {
                      //       this.maintainOrderChangeMaintainerId = params.row.id
                      //       this.maintainOrderChangeMaintainerModal = true
                      //     }
                      //   }
                      // }, '指派维修员'),
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.maintainVehiclePictureModalId = params.row.id
                            this.maintainVehiclePictureModal = true
                          }
                        }
                      }, '图片管理'),
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.changeBusinessUserModal = true
                            this.changeBusinessUserId = params.row.id
                          }
                        }
                      }, '指定跟进业务'),
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.maintainOrderAddToRemarkModal = true
                            this.maintainOrderAddToRemarkId = params.row.id
                          }
                        }
                      }, '追加备注'),
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.$Modal.confirm({
                              title: '提示',
                              content: '<p>确认维修</p>',
                              onOk: () => {
                                store.dispatch('MaintainOrderServ_ConfirmMaintained', {
                                  params: { id: params.row.id }
                                }).then(() => {
                                  this.$Message.success('确认维修完成')
                                  this.onModifySuccess()
                                }).catch(err => {
                                  this.$Message.error(err)
                                })
                              },
                              onCancel: () => {

                              }
                            })
                          }
                        }
                      }, '确认维修完成'),
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.$Modal.confirm({
                              title: '提示',
                              content: '<p>后台确认维修</p>',
                              onOk: () => {
                                store.dispatch('MaintainOrderServ_ForceConfirmMaintained', {
                                  params: { id: params.row.id }
                                }).then(() => {
                                  this.$Message.success('后台确认维修完成')
                                  this.onModifySuccess()
                                }).catch(err => {
                                  this.$Message.error(err)
                                })
                              },
                              onCancel: () => {

                              }
                            })
                          }
                        }
                      }, '后台确认维修完成'),
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.$Modal.confirm({
                              title: '提示',
                              content: '<p>确认作废</p>',
                              onOk: () => {
                                store.dispatch('MaintainOrderServ_Cancel', {
                                  params: { id: params.row.id }
                                }).then(() => {
                                  this.$Message.success('确认作废完成')
                                  this.onModifySuccess()
                                }).catch(err => {
                                  this.$Message.error(err)
                                })
                              },
                              onCancel: () => {

                              }
                            })
                          }
                        }
                      }, '作废订单')
                    ]
                  )
                ]
                )
              )
            }

            return h('div', display)
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'MaintainOrderServ_GetMyUserGroupPage'
    ]),
    rowClassName (row, index) {
      // if (row.bookingDatetime) {
      //   if (row.state == 1 || row.state == 2) {
      //     if (row.bookingDatetime + 86400000 < new Date().getTime()) {
      //       // console.log(row)
      //       // console.log(index)
      //       return 'demo-table-error-row'
      //     }
      //   }
      // }
      if (row.state != 3) {
        if (row.timeoutLogo) {
          return 'demo-table-error-row'
        } else {
          return ''
        }
      }
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '维修员') {
          this.columns[i].filters = this.maintainers
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '销售渠道') {
          this.columns[i].filters = this.allSalesChannels
          break
        }
      }
    },
    onFilterClick () {
      this.FilterClickFilter = null
      this.setPage(1)
    },
    DropdownonFilterClick (name) {
      this.FilterClickFilter = name
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let qo5 = null
      let qo6 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('updateDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [genQueryParam('state', 'EQ', 1),
          genQueryParam('state', 'EQ', 2),
          genQueryParam('state', 'EQ', 3),
          // genQueryParam('state', 'EQ', 4),
          genQueryParam('state', 'EQ', 5),
          genQueryParam('state', 'EQ', 6)
          // genQueryParam('state', 'EQ', 7),
        ]
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.fileReadyFilter) {
        queryParams.push(this.fileReadyFilter)
      }
      if (this.businessUserFilter) {
        qo2 = this.businessUserFilter
      }
      if (this.maintainerFilter) {
        qo3 = this.maintainerFilter
      }
      if (this.changesimFilter) {
        qo4 = this.changesimFilter
      }
      if (this.maintainTypeFilter) {
        qo5 = this.maintainTypeFilter
      }
      if (this.timeoutLogoFilter) {
        qo6 = this.timeoutLogoFilter
      }
      if (this.selectServiceDatetime[0] && this.selectServiceDatetime[1]) {
        let startDatetime = new Date(this.selectServiceDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectServiceDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        if (this.FilterClickFilter != null) {
          queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
        } else {
          queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
        }
      }

      store.dispatch('MaintainOrderServ_GetMyBusinessPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          qo5: qo5,
          qo6: qo6,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
        if (store.getters.get_MaintainOrder_GetPageResult.content != null) {
          store.getters.get_MaintainOrder_GetPageResult.content.forEach(item => {
            if (item.maintainDeviceRecords != null) {
              item.maintainDeviceRecords.forEach(item2 => {
                if (item2.changeSim) {
                  store.dispatch('SimInfoServ_SearchBySimShortNum', {
                    params: { simShortNum: item2.newTerminalNum },
                    urlparams: {}
                  }).then(res => {
                    // console.log(store.getters.get_SimInfo_SearchBySimShortNumResult[0].simNum)
                    let Sim = store.getters.get_SimInfo_SearchBySimShortNumResult[0].simNum
                    Vue.set(item2, 'simInfo', Sim)
                  }).catch(err => {

                  })
                } else {
                  Vue.set(item2, 'simInfo', null)
                }
              })
            }
          })
        }
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onTest () {
      store.dispatch('MaintainOrderServ_OmTest', {
        params: null,
        urlparams: null
      }).then(() => {
        this.$Message.success('测试')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    // computeCol() {
    //   let columns = this.columns
    //   columns = columns.filter(col => {
    //     for (var i = 0; i < this.columnsDisplay.length; i++) {
    //       if (this.columnsDisplay[i] === col.title) {
    //         return true
    //       }
    //     }
    //     return false
    //   })
    //   return columns
    // },
    totalElements () {
      if (store.getters.get_MaintainOrder_GetMyBusinessPageResult) {
        return store.getters.get_MaintainOrder_GetMyBusinessPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_MaintainOrder_GetMyBusinessPageResult) {
        return store.getters.get_MaintainOrder_GetMyBusinessPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_MaintainOrder_GetMyBusinessPageResult) {
        return store.getters.get_MaintainOrder_GetMyBusinessPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // this.columns.forEach(item => {
      //   this.columnHeaders.push(item.title)
      //   this.columnsDisplay.push(item.title)
      // })
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8] }
      }).then(() => {
        let maintainers = store.getters.get_User_GetAllUsersResult
        this.maintainers = maintainers.map(item => {
          return { label: item.realName, value: item.id }
        })
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          let marketsales = store.getters.get_User_GetAllUsersResult
          this.marketsales = marketsales.map(item => {
            return { label: item.realName, value: item.id }
          })
          // this.columns[4].filters = this.renewalers
          // this.columns[11].filters = this.marketsales
          this.onColumnUpdate()
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style>
  .ivu-table .demo-table-info-row td {
    background-color: #2db7f5;
    color: #fff;
  }

  .ivu-table .demo-table-error-row td {
    background-color: #82b455;
    color: #000000;
  }
</style>
